import { api } from "../app/api";
import { useAsync } from "../app/useAsync";
import { StatusChip } from "../components/StatusChip";

export function DatabaseStatusPage() {
  const health = useAsync(api.health, []);
  const tables = useAsync(api.tables, []);

  const db = health.data?.database;

  return (
    <>
      <h1>Database Status</h1>
      <p className="page-sub">
        Cloudflare D1 operational database (migration jobs, matches, logs,
        errors, id map).
      </p>

      <div className="card" style={{ marginBottom: "1.2rem" }}>
        <h3>Connection</h3>
        {health.loading ? (
          <span className="muted">checking…</span>
        ) : db?.connected ? (
          <>
            <StatusChip tone="ok" label="Connected" />
            <p className="muted" style={{ marginTop: 10 }}>
              {db.name ?? "—"} · {health.data?.environment} ·{" "}
              {db.latencyMs != null ? `${db.latencyMs}ms` : "—"}
            </p>
          </>
        ) : (
          <>
            <StatusChip tone="no" label="Not connected" />
            {db?.error && (
              <p className="muted" style={{ marginTop: 10 }}>
                {db.error}
              </p>
            )}
          </>
        )}
      </div>

      <div className="card">
        <h3>Tables</h3>
        {tables.loading && <p className="muted">Loading…</p>}
        {tables.error && (
          <p className="muted">
            Unavailable ({tables.error}). Ensure migrations have been applied.
          </p>
        )}
        {tables.data && (
          <table>
            <thead>
              <tr>
                <th>Table</th>
                <th>Rows</th>
              </tr>
            </thead>
            <tbody>
              {tables.data.tables.map((t) => (
                <tr key={t.name}>
                  <td>
                    <code>{t.name}</code>
                  </td>
                  <td className="muted">{t.rows}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
